let site = 'goodbeefindex';

export const getGBIDomain = () => {
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:8080';
  } else if (window.location.hostname === 'test.beefbook.com') {
    return 'https://test.goodbeefindex.org';
  }
  return 'https://goodbeefindex.org';
};

export const getBeefBookDomain = () => {
  if (window.location.hostname.includes('localhost')) {
    return 'http://localhost';
  } else if (window.location.hostname.includes('test')) {
    return 'https://test.beefbook.com';
  } else {
    return 'https://beefbook.com';
  }
};

export const getDashboardDomain = () => {
  if (window.location.hostname.includes('localhost')) {
    return 'http://localhost:8088';
  } else if (window.location.hostname.includes('test')) {
    return 'https://test-dash.goodbeefindex.org';
  } else {
    return 'https://dash.goodbeefindex.org';
  }
};

export default site;
